module.exports = __webpack_public_path__ + "static/media/astro.c58bff53.svg";